export const MAX_BULLET_AMOUNT = 10;
